import { render } from "./ServiceDetailsHeader.vue?vue&type=template&id=2c9c4ff4"
import script from "./ServiceDetailsHeader.vue?vue&type=script&lang=js"
export * from "./ServiceDetailsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__